import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "text-2xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "text-normal text-gray-400 mt-1" }
const _hoisted_4 = {
  key: 0,
  class: "bg-white rounded-xl border border-gray-200 p-6"
}
const _hoisted_5 = {
  key: 1,
  class: "bg-white rounded-xl border border-gray-200 divide-y divide-gray-100"
}
const _hoisted_6 = { class: "flex items-center justify-between px-6 py-4" }
const _hoisted_7 = { class: "text-normal font-medium text-gray-800" }
const _hoisted_8 = { class: "text-sm text-gray-400 mt-0.5" }
const _hoisted_9 = {
  key: 2,
  class: "mt-3 text-xs text-error-500"
}

import { ref, onMounted } from 'vue';
import { useToast } from 'vue-toastification';
import { useI18n } from 'vue-i18n';
import AppToggle from '@/components/ui/AppToggle.vue';
import { notificationsApi } from '@/api/notifications';


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const toast = useToast();
const { t } = useI18n();

const loading = ref(true);
const saving = ref(false);
const saveError = ref(false);
const emailEnabled = ref(false);

onMounted(async () => {
    try {
        const prefs = await notificationsApi.getPreferences();
        emailEnabled.value = prefs.emailEnabled;
    } catch {
        // Leave defaults
    } finally {
        loading.value = false;
    }
});

async function save() {
    if (saving.value) return;
    saving.value = true;
    saveError.value = false;
    try {
        await notificationsApi.updatePreferences({ emailEnabled: emailEnabled.value });
        toast.success(t('account.notifications.saved'));
    } catch {
        saveError.value = true;
        toast.error(t('errors.unknown'));
    } finally {
        saving.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('account.notifications.title')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('account.notifications.description')), 1)
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "animate-pulse h-8 bg-gray-100 rounded w-full" }, null, -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('account.notifications.emailLabel')), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('account.notifications.emailDescription')), 1)
            ]),
            _createVNode(AppToggle, {
              modelValue: emailEnabled.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((emailEnabled).value = $event)),
                save
              ]
            }, null, 8, ["modelValue"])
          ])
        ])),
    (saveError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('errors.unknown')), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})